import React, { useState } from "react";
import DropdownList from "../../../Patient/partial/DropdownList";
import DatePicker from "react-datepicker";
import Editor from "../../../../partials/Editor";

const NewNoteForm = ({ onSubmit, onCancel, categories }) => {
    // local state
    const [category, setCategory] = useState(null);
    const [confirm, setConfirm] = useState(false);
    const [note, setNote] = useState();

    // ref
    const summaryRef = React.createRef();
    const [datetime, setDatetime] = useState(new Date());

    return (
        <form
            method="POST"
            onSubmit={(event) => {
                event.preventDefault();
                onSubmit({
                    confirm,
                    notes: [
                        {
                            category,
                            note,
                            summary: summaryRef.current.value,
                            datetime,
                        },
                    ],
                });
                summaryRef.current.value = "";
            }}
        >
            <div className="form-row">
                <div className="col">
                    <DropdownList onSelect={(item) => setCategory(item.id)} items={categories} title="Category" />
                </div>
                <div className="col">
                    <label htmlFor="datetime-id">Datetime</label>
                    <DatePicker selected={datetime} onChange={(date) => setDatetime(date)} className="form-control input-height" timeIntervals={15} dateFormat="MMMM d, yyyy" />
                </div>
            </div>
            <div className="form-group">
                <label htmlFor="summary-id">Summary</label>
                <input type="text" className="form-control input-height" id="summary-id" required ref={summaryRef} aria-describedby="summary-id" placeholder="enter summary" />
            </div>

            <div className="form-group">
                <label htmlFor="note">Note</label>
                <Editor placeholder="Enter note here" content={note} onChange={(_note) => setNote(_note)} />
                <small id="note" className="form-text text-muted">
                    Clinical Note/Plan Note
                </small>
            </div>
            <div className="form-group">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" onChange={(event) => setConfirm(event.target.checked)} className="custom-control-input" id="customCheck1" />
                    <label className="custom-control-label" htmlFor="customCheck1">
                        Confirm note upon saving
                    </label>
                </div>
            </div>
            <div className="text-center">
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default">
                    <i className="material-icons text-danger">cancel</i> Cancel
                </button>

                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-success">
                    Save Note <i className="material-icons">arrow_right_alt</i>
                </button>
            </div>
        </form>
    );
};

export default NewNoteForm;
